<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Contato" posicao="left" />
    <div class="container">
      <!-- <div class="col-md-10 col-lg-8 col-xl-6 col-xxl-4 offset-md-1 offset-lg-2 offset-xl-3 offset-xxl-4 py-3"> -->
      <div class="row">
        <div class="col-md-6 bg-fixo" id="contact-side">
          <div class="h4 paragrafo rounded-4">
            <p>
              Não perca tempo, cadastre-se gratuitamente e tenha acesso aos nossos cursos.
            </p>
          </div>
        </div>
        <div class="col-md-6 pb-3 shadow-lg mb-5" id="form_contato">
          <div class="alert alert-primary" role="alert">
            Não exite entrar em contato, assim que pudermos iremos lhe responder, insira seus dados reais para
            retornarmos.
          </div>
          <form @submit.prevent="enviarMensagem">
            <InputText label="Nome *" placeholder="" v-model="contato.nome" />
            <InputTextMask placeholder="" nome="celular" label="Celular *" mask="cel" tamanho="sm"
              v-model="contato.celular" />
            <InputText tipo="email" nome="email" label="Email" placeholder="" v-model="contato.email" />
            <InputTextarea nome="mensagem" label="Mensagem *" v-model="contato.mensagem" />
            <div class="d-grid gap-2 mx-auto">
              <button type="submit" class="btn btn-success btn-lg" @click.prevent="enviarMensagem">
                Enviar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import TituloGrande from '@/components/TituloGrande.vue'
import InputTextMask from '@/components/form/InputTextMask.vue';
import InputTextarea from '@/components/form/InputTextarea.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { bloqueia_campos, mensagem_request, meta_default } from '@/assets/js/functions';
export default {
  components: { TituloGrande, InputText, InputTextMask, InputTextarea },
  name: 'Contato',
  data() {
    return {
      contato: {}
    }
  },
  metaInfo: {
    title: 'Contato',
    meta: meta_default("Contato")
  },
  methods: {
    async enviarMensagem() {

      if (!this.contato.nome) {
        toastr.alerta("Digite seu nome")
        document.querySelector("#nome").focus()
        return false
      }

      if (!this.contato.celular) {
        toastr.alerta("Digite seu celular")
        document.querySelector("#celular").focus()
        return false
      }

      if (!this.contato.email) {
        toastr.alerta("Digite seu email")
        document.querySelector("#email").focus()
        return false
      }

      if (!this.contato.mensagem) {
        toastr.alerta("Digite seu mensagem")
        document.querySelector("#mensagem").focus()
        return false
      }
      bloqueia_campos()

      const data = await api.post('contato/envia_mensagem', this.contato)
      
      mensagem_request(data)
      
      bloqueia_campos(false)
    }
  },
}
</script>

<style scoped>
#form_contato {
  padding-top: 40px;
  margin-top: -30px;
  padding-bottom: 40px;
  background-color: var(--cor-base-branco-transp);
}

#contact-side {
  background-color: var(--cor-base-branco-transp);
  padding: 20px;
  border-radius: 10px;
}

#contact-side::before {
  background-image: url('/public/img/visao.jpg');
}
</style>